export const MRC_BILL_CP52_FORM_KEY = 'eops:mrcBillCp52Form';

export const openMrcBillTab = ({
    applicationId,
    oracleTrackingId = '',
    isPostedToIPS = false,
    cp52FormData = null,
    payableWithinDueDate = '',
    customerId = '',
} = {}) => {
    const params = new URLSearchParams();
    if (applicationId) params.set('applicationId', applicationId);
    if (oracleTrackingId) params.set('oracleTrackingId', oracleTrackingId);
    params.set('isPostedToIPS', isPostedToIPS ? 'true' : 'false');
    if (
        payableWithinDueDate != null &&
        String(payableWithinDueDate).trim() !== ''
    ) {
        params.set('payableWithinDueDate', String(payableWithinDueDate).trim());
    }
    if (customerId != null && String(customerId).trim() !== '') {
        params.set('customerId', String(customerId).trim());
    }

    const query = params.toString() ? `?${params.toString()}` : '';

    // Auth lives in sessionStorage (per-tab). Bridge a copy so the new bill tab
    // can rehydrate without being treated as a fresh/closed-tab logout.
    try {
        const persistRoot = sessionStorage.getItem('persist:root');
        if (persistRoot) {
            localStorage.setItem('eops:billTabAuthBridge', persistRoot);
            localStorage.setItem('eops:billTabAuthBridgeAt', String(Date.now()));
        }
        // Pass already-prepared CP52 form (meter + consumer fields) to bill tab.
        if (cp52FormData && typeof cp52FormData === 'object') {
            localStorage.setItem(
                MRC_BILL_CP52_FORM_KEY,
                JSON.stringify(cp52FormData)
            );
        } else {
            localStorage.removeItem(MRC_BILL_CP52_FORM_KEY);
        }
    } catch (e) {
        // ignore
    }

    const opened = window.open(
        `${window.location.origin}/mrc-bill${query}`,
        '_blank'
    );

    if (!opened) {
        try {
            localStorage.removeItem('eops:billTabAuthBridge');
            localStorage.removeItem('eops:billTabAuthBridgeAt');
            localStorage.removeItem(MRC_BILL_CP52_FORM_KEY);
        } catch (e) {
            // ignore
        }
        window.alert('Please allow pop-ups to open the MRC bill.');
    }
};
